import { Routes, Route } from 'react-router-dom';
import SubmitterForm from './pages/SubmitterForm';
import CustomForm from './pages/CustomForm';
import SubmitSuccess from './pages/SubmitSuccess';
import AdminInbox from './pages/AdminInbox';
import AdminActivity from './pages/AdminActivity';
import AdminSettings from './pages/AdminSettings';
import AdminForms from './pages/AdminForms';
import Smoke from './pages/Smoke';
import Setup from './pages/Setup';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import { ProtectedRoute } from './lib/auth';

// Routing per PROJECT_BRIEF.md §8.
// Phase 3a wires the auth routes and gates /admin behind ProtectedRoute.
// AdminInbox still renders mock data; live data wiring is Phase 3b.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<SubmitterForm />} />
      <Route path="/f/:slug" element={<CustomForm />} />
      <Route path="/success" element={<SubmitSuccess />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminInbox />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/activity"
        element={
          <ProtectedRoute>
            <AdminActivity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/forms"
        element={
          <ProtectedRoute>
            <AdminForms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/forms/:id"
        element={
          <ProtectedRoute>
            <AdminInbox />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/forms/new"
        element={
          <ProtectedRoute>
            <AdminForms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/forms/:id/edit"
        element={
          <ProtectedRoute>
            <AdminForms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        }
      />
      <Route path="/smoke" element={<Smoke />} />
    </Routes>
  );
}
